export const formatNumber0 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    }).format(number) : '-';
}

export const formatNumber1 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
        useGrouping: true
    }).format(number) : '-';
}

export const formatNumber2 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
    }).format(number) : '-';
}

/**
 * Compact number with SI-style suffixes for large values:
 *   999 → "999", 1_234 → "1,2k", 133_856 → "134k", 2_500_000 → "2,5M",
 *   3_000_000_000 → "3Mrd". Values below 1000 are shown in full (with grouping).
 * Reusable across panels (gateway metrics, dashboards, ...). The decimal
 * separator follows the given locale (default de-DE → comma).
 */
export const formatCompactNumber = (number: number, locale = 'de-DE') => {
    if (number == null || Number.isNaN(number)) {
        return '-';
    }

    const abs = Math.abs(number);
    const units = [
        { value: 1e12, symbol: 'Bio' },
        { value: 1e9, symbol: 'Mrd' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'k' },
    ];

    for (const { value, symbol } of units) {
        if (abs >= value) {
            const scaled = number / value;
            // One decimal below 10 (e.g. 1,2k), none above (e.g. 134k).
            const maximumFractionDigits = Math.abs(scaled) < 10 ? 1 : 0;

            return `${Intl.NumberFormat(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits,
            }).format(scaled)}${symbol}`;
        }
    }

    return Intl.NumberFormat(locale, {
        maximumFractionDigits: 0,
        useGrouping: true,
    }).format(number);
}
